import { functions } from '@/assets/script/functions'

const categories = {
  state: {
    SortedCategories: [],
    selectedMainCategories: []
  },
  mutations: {
    setSortedCategoriesState(state, sortedCategories){
      state.SortedCategories = sortedCategories
    },
    setMainCategoriesState(state, mainCategories){
      state.selectedMainCategories = mainCategories
    }
  },
  actions: {
    async setSortedCategories({commit, dispatch, getters}){
      const uniqueCategories = await dispatch('getUniqueCategories', getters.allRecipes)
      const sortedCategories = await dispatch('getSortedCategories', uniqueCategories)
      commit('setSortedCategoriesState', sortedCategories)
    },
    // Gets all unique categories from recipes
    getUniqueCategories(state, recipes){
      const recipeCategories = []
      recipes.forEach(recipe => { recipeCategories.push(...recipe.Categories) })
      return functions.getUnique(recipeCategories, 'Parent').map(category => category.Parent)
    },
    // Put recipes into categories
    getSortedCategories({getters}, unique){
      const sortedCategories = []
      unique.forEach(uniqueParent => {
				const recipes = {
					Name: '',
					Categories: []
				}
				recipes.Name = uniqueParent
				getters.allRecipes.forEach(recipe => {
					recipe.Categories.forEach(category => {
						if(category.Parent ==  uniqueParent)
							recipes.Categories.push({ name: category.Name, recipe })
					})
				})
				sortedCategories.push(recipes);
      })
      const mappedAndSortedCategories = sortedCategories.map(category => {
        return {"name": category.Name, "categories": category.Categories}
      })
      return mappedAndSortedCategories
    },
    // Sets all "first layer" categories
    setSelectedMainCategory({commit, state, dispatch}, name){
      const mainCategories = state.selectedMainCategories
      const isFiltered = mainCategories.indexOf(name);
      if(isFiltered == -1)
        mainCategories.push(name)
      else
        mainCategories.splice(isFiltered, 1)
      if(mainCategories.length == 0){
        commit('setMainCategoriesState', [])
        dispatch('setFilteredRecipes')
      }
      else{
        commit('setMainCategoriesState', mainCategories)
        dispatch('setFilteredRecipes')
      }
    },
    clearSelectedCategories({commit, dispatch}){
      commit('setMainCategoriesState', [])
      commit('setSelectedSubCatState', [])
      dispatch('setFilteredRecipes')
    },
  },
  getters: {
    mainMenu: state => state.SortedCategories.map(category => category.name),
    selectedMainCategories: state => state.selectedMainCategories,
    sortedCategories: state => state.SortedCategories
  }
}
export default categories